"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UmaCare = void 0;
class UmaCare {
    constructor(props) {
        this.active = props?.active,
            this.can_receive_ws = props?.can_receive_ws,
            this.causes = props?.causes,
            this.country = props?.country,
            this.dt_cierre = props?.dt_cierre,
            this.initial_symptoms = props?.initial_symptoms,
            this.medicalRecord = props?.medicalRecord,
            this.patient = props?.patient,
            this.resp = props?.resp,
            this.response_counter = props?.response_counter,
            this.responses = props?.responses,
            this.specialist_referral = props?.specialist_referral,
            this.start_date = props?.start_date,
            this.swab = props?.swab,
            this.uid = props?.uid,
            this.vaccination = props?.vaccination,
            this.umaCareId = props?.umaCareId,
            this.timestamps = props?.timestamps;
    }
}
exports.UmaCare = UmaCare;
